import React, { useState, useCallback } from 'react'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'

import { GetCard } from '@web/walter-lib/api'
import s from './s.module.css'
import { lang } from './lang'
import Approve from './Approve'
import ListWrapper from './ListWrapper'
import ApprovalModal from '~pages/CardsPage/Cards/Transactions/ApproveModal'
import { Transaction } from '~pages/CardsPage/Cards/Transactions/types'
import { useGetThreeDSChallengesData } from '~api'
import { useCardDetailsStore } from '~store/cardDetails'

interface Props {
    card?: GetCard
    txNow?: number
}

function Transactions({ card, txNow }: Props) {
    const { data: chs } = useGetThreeDSChallengesData()
    const challenges = chs?.challenges

    const transactionCount = challenges?.filter(challenge => challenge.card_id === card?.id)?.length || 0

    const [isApprovalOpen, setIsApprovalOpen] = useState(false)
    const { setData } = useCardDetailsStore()

    const onRowClick = useCallback(
        (tx: Transaction) => {
            setData({ isOpen: true, tx })
        },
        [setData]
    )

    return (
        <>
            <ApprovalModal
                isOpen={isApprovalOpen}
                onRowClick={onRowClick}
                onClose={() => setIsApprovalOpen(false)}
                initCardId={card?.id}
            />
            <div className={s.wrap}>
                <FormattedHTMLMessage {...lang.title} className={s.title} />
                {transactionCount > 0 && (
                    <Approve onClick={() => setIsApprovalOpen(true)} transactionCount={transactionCount} />
                )}
                {card?.id && (
                    <div key={card?.id + txNow} className={s.list}>
                        <ListWrapper onRowClick={onRowClick} card={card} />
                    </div>
                )}
            </div>
        </>
    )
}

export default Transactions
